<template>
  <div class="index">
    <div class="top">
      <div class="top_left">
        <van-dropdown-menu active-color="#2A8FF7">
          <van-dropdown-item
            v-model="value1"
            :options="option1"
            @change="changeStatus"
          />
        </van-dropdown-menu>
      </div>
      <div class="top_right">
        <van-search
          shape="round"
          v-model="searchVal"
          @search="onSearch"
          placeholder="请输入搜索关键词"
        />
      </div>
    </div>
    <div class="main">
      <div v-if="list.length > 0">
        <div class="main_content" v-for="(item, index) in list" :key="index">
          <div class="content_left">
            <div class="m16">客户名称</div>
            <div class="m16">业务类型</div>
            <div class="m16">预约进度</div>
            <div class="m16">预约日期</div>
          </div>
          <div class="content_center">
            <div class="m17">{{ item.name }}</div>
            <div class="m17">{{ item.serviceName }}</div>
            <div class="m17" v-if="item.status == 0">已取消</div>
            <div class="m17" v-if="item.status == 1">已提交</div>
            <div class="m17" v-if="item.status == 2">已完成</div>
            <div class="m17">{{ item.serviceTime }}</div>
          </div>
          <div class="content_right">
            <div
              class="contact"
              v-show="item.status == 1"
              @click="completeService(item.id)"
            >
              完成服务
            </div>
            <div
              class="contact2"
              v-show="item.status != 1"
            >
            </div>
            <div class="complete" @click="daPhone(item.mobile)">联系客户</div>         
            <div class="detail" @click="skipDetail(item.id)">预约详情</div>
          </div>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无预约" />
      </div>
    </div>
  </div>
</template>
  <script>
import { appointmentList, editStatus } from "../../api/appointment";
export default {
  data() {
    return {
      searchVal: "",
      value1: "",
      option1: [
        { text: "预约状态", value: "" },
        { text: "已取消", value: 0 },
        { text: "已提交", value: 1 },
        { text: "已完成", value: 2 },
      ],
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeStatus() {
      this.getList();
    },
    getList() {
      appointmentList({ status: this.value1, key: this.searchVal }).then(
        (res) => {
          this.list = res.data.list;
        }
      );
    },
    onSearch() {
      this.getList();
    },
    completeService(id) {
      editStatus({ id, status: 2 }).then((res) => {
        if (res.code == 200) {
          this.$toast("成功完成！");
          this.getList();
        }
      });
    },
    skipDetail(id) {
      this.$router.push({
        path: "/appointment/detail",
        query: { id },
      });
    },
    daPhone(tel) {
      window.location.href = `tel:${tel}`;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-dropdown-menu__bar {
  background-color: #f2f3f7;
  box-shadow: none;
  height: 54px;
}
/deep/ .van-search {
  background-color: #f2f3f7;
}
/deep/ .van-ellipsis {
  font-size: 13px;
}
/deep/ .van-search__content {
  background-color: #fff;
}
.index {
  height: 100%;
  width: 100%;
  background-color: #f2f3f7;
}
.top {
  display: flex;
  justify-content: space-between;
  width: 91%;
  margin: 0 auto;
  margin-bottom: 18px;
  .top_left {
    font-size: 14px;
    color: #4a4a4a;
    height: 40px;
    background-color: #f2f3f7;
  }
  .top_right {
    width: 270px;
    height: 34px;
    background-color: #f2f3f7;
  }
}
.main {
  .main_content {
    width: 100%;
    height: 150px;
    background: #fff;
    margin-bottom: 10px;
    .content_left {
      padding: 0 15px 0 17px;
      height: 37px;
      line-height: 37px;
      float: left;
      font-size: 15px;
      color: #4a4a4a;
    }
    .content_center {
      width: 56%;
      height: 37px;
      line-height: 37px;
      float: left;
      font-size: 15px;
      color: #959595;
    }
    .content_right {
        height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      float: left;
      font-size: 12px;
      .contact {
        width: 65px;
        height: 22px;
        line-height: 22px;
        border-radius: 11px;
        text-align: center;
        color: #fff;
        background-color: #2a8ff7;
        margin-top: 20px;
      }
      .contact2 {
        width: 65px;
        height: 22px;
        margin-top: 20px;
      }
      .complete {
        width: 65px;
        height: 22px;
        line-height: 22px;
        background: #dfefff;
        border-radius: 11px;
        text-align: center;
        color: #2a8ff7;
        margin: 18px 0 24px 0;
      }
      .detail {
        height: 16px;
        font-size: 12px;
        text-align: center;
        color: #2a8ff7;
        line-height: 16px;
      }
    }
  }
}
</style>